import { render, staticRenderFns } from "./SidenavNew.vue?vue&type=template&id=20004240&"
import script from "./SidenavNew.vue?vue&type=script&lang=js&"
export * from "./SidenavNew.vue?vue&type=script&lang=js&"
import style0 from "./SidenavNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports